<div class="card profile-information id-information-card linked mt-3" id="information">
    <div class="container-fluid card-body p-0">
        <div class="row no-gutters">
            <div class="col-12 p-2">
                <span class="id-information-title"> {{'profile.lastValidatedOn' | i18next}} {{lastValidationDate | amDateFormat: 'LLL'}} </span>
            </div>
        </div>
    </div>
</div>